import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spin, Pagination } from "antd";
import "./styles.css";
import { ApiCaller, Colors, Utils } from "../../config";
import {
  Button,
  ImageGrid,
  Modal,
  TextField,
  TruncatedEmail,
  TruncatedName,
} from "../../components";
import Profile from "../../assets/images/profile.png";
import { ReportAction } from "../../store/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

const ReportManagement = () => {
  const [isFeedbackTab, setIsFeedbackTab] = useState(true);
  // const [, setPage] = useState(1);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [state, setState] = useState({
    status: "",
    responded: "",
    page: 1,
  });
  const page = state.page;
  const setPage = (pageNumber) => {
    setState({ ...state, page: pageNumber });
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [reportType, setReportType] = useState("post");

  const handleSeeMore = (data) => {
    if (data) {
      setSelectedData(data);
    }
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedItem(null); // Clear the selected item on close
  };

  const handleOptionClick = (option) => {
    console.log({ option });
    setSelectedItem(option); // Set the selected option
    handleSeeMore(); // Open the modal
  };
  const predefinedReasons = [
    "Inappropriate Content",
    "Misinformation",
    "Spam or Scams",
    "Impersonation",
    "Privacy Violation",
    "Harmful Behavior",
    "Copyright Infringement",
    "Offensive Language",
    "Other",
  ];

  const perPage = 3; // Number of reports per page
  const dispatch = useDispatch();
  const s3Bucket = process.env.REACT_APP_MEDIA_BASE_URL;

  const fetchReports = (pageNum, type = reportType) => {
    const payload = {
      limit: perPage,
      page: pageNum,
      type: type, // Use dynamic type
      responded: state.responded,
    };

    console.log("Fetching reports with payload:", payload);

    setLoading(true);
    dispatch(
      ReportAction.getReports(payload, (response) => {
        setLoading(false);
        if (response) {
          console.log("API Response:", response?.data);
          setCards(response?.data);
          setTotal(response.paginate.total);
        } else {
          console.log("API call failed or no data returned.");
        }
      })
    );
  };

  const handleRespondedChange = (value) => {
    const responded = value === "all" ? "" : value === "active" ? 0 : 1;
    setState((prevState) => ({
      ...prevState,
      page: 1,
      responded: responded,
    }));
    fetchReports(1, reportType); // Fetch reports with the updated responded state
  };

  const handleDelete = async (postId) => {
    if (!postId) return;

    // Declare resourceType here to ensure it's accessible in the catch block
    const resourceType = reportType === "interview" ? "interview" : "post";

    try {
      setLoading(true);

      const response = await ApiCaller.Delete(`/${resourceType}/${postId}`);

      if (response?.status === 200 || response?.status === 201) {
        console.log(
          `${
            resourceType.charAt(0).toUpperCase() + resourceType.slice(1)
          } deleted successfully:`,
          response
        );
        fetchReports(page);
        Utils.showSnackBar({
          message: `${
            resourceType.charAt(0).toUpperCase() + resourceType.slice(1)
          } deleted successfully`,
        });
      } else {
        Utils.showSnackBar({
          message: `Failed to delete the ${resourceType}`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(`Error deleting the ${resourceType}:`, error);
      Utils.showSnackBar({
        message: error.response?.data?.message || "An error occurred",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuspendUser = async (userId, reportId) => {
    try {
      setLoading(true);
      const response = await ApiCaller.Put(
        `/users/status/toggle?user_id=${userId}&report_id=${reportId}`
      );
      if (response?.status === 201 || response?.status === 204) {
        Utils.showSnackBar({ message: response?.data?.message });
        fetchReports(page);
      } else {
        Utils.showSnackBar({
          message: "Failed to suspend the reporter",
          severity: "error",
        });
      }
    } catch (error) {
      Utils.showSnackBar({
        message: error.response?.data?.message || "An error occurred",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuspendReporter = async (userId, reportId) => {
    try {
      setLoading(true);
      const response = await ApiCaller.Put(
        `/users/status/toggle?user_id=${userId}&report_id=${reportId}`
      );
      if (response?.status === 201 || response?.status === 204) {
        Utils.showSnackBar({ message: response?.data?.message });
        fetchReports(page);
      } else {
        Utils.showSnackBar({
          message: "Failed to suspend the reporter",
          severity: "error",
        });
      }
    } catch (error) {
      Utils.showSnackBar({
        message: error.response?.data?.message || "An error occurred",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports(page); // Fetch reports when the component mounts or page changes
  }, [page, state.responded]);

  return (
    <div className="report-management-container">
      <h2 className="text-black flex flex-start text-2xl">
        Reports Management
      </h2>
      <Row className="flex-row justify-between align-center">
        <Col className="flex-row mb-10 mt-5">
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor:
                reportType === "post" ? Colors.BlueText : Colors.LightBlue,
              borderRadius: "5px 0px 0px 5px",
              color: reportType === "post" ? Colors.White : Colors.Black,
            }}
            onClick={() => {
              setReportType("post");
              fetchReports(1, "post"); // Fetch post data immediately
            }}
            text={"Post"}
          />
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor:
                reportType === "interview" ? Colors.BlueText : Colors.LightBlue,
              borderRadius: "0px 5px 5px 0px",
              color: reportType === "interview" ? Colors.White : Colors.Black,
            }}
            onClick={() => {
              setReportType("interview");
              fetchReports(1, "interview"); // Fetch interview data immediately
            }}
            text={"Interviews"}
          />
        </Col>

        <Col span={4}>
          <TextField.SelectField
            inputStyle={{ width: "100%" }}
            className="listing-filter"
            size={"large"}
            allowClear={false}
            onChange={handleRespondedChange}
            value={
              state.responded === ""
                ? "all"
                : state.responded === 0
                ? "active"
                : "inactive"
            }
            options={[
              {
                label: "View All",
                value: "all",
              },
              {
                label: "Pending",
                value: "active",
              },
              {
                label: "Responded",
                value: "inactive",
              },
            ]}
          />
        </Col>
      </Row>
      <Spin spinning={loading}>
        <Row justify="" gutter={[16, 16]}>
          {cards.map((report, index) => (
            <Col xs={24} sm={12} lg={8} key={report.id}>
              <Card className="report-card" bordered={true}>
                <Row gutter={[8, 16]} className="flex-col">
                  {/* Reported By Section */}
                  <Col span={24}>
                    <Row justify="space-between">
                      <Col>
                        <Row align="middle">
                          <Col>
                            <img
                              src={
                                report?.reporter?.profile_photo
                                  ? `${s3Bucket}${report.reporter.profile_photo}`
                                  : Profile
                              }
                              alt="Reporter"
                              className="w-12 h-12 rounded-full"
                            />
                          </Col>

                          <Col
                            style={{
                              marginLeft: "5px",
                              padding: "0",
                              marginBottom: "0",
                            }}
                          >
                            <TruncatedName
                              name={report?.reporter?.name}
                              maxLength={9}
                              className="text-md font-bold mb-0 "
                              style={{}}
                            />
                            <TruncatedEmail
                              email={report?.reporter?.email}
                              maxLength={14}
                              style={{
                                color: Colors.LightGray,
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <h3
                            className="font-bold"
                            style={{
                              color: Colors.BabyPink,
                            }}
                          >
                            Reporter
                          </h3>
                          <p
                            className="text-xs"
                            style={{ color: Colors.LightGray }}
                          >
                            {report?.reported_at
                              ? moment(report.reported_at).format(
                                  "DD/MM/YYYY HH:mm"
                                )
                              : "No date available"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  {/* Reason for Reporting Section */}
                  <Col span={24} className="flex flex-col text-left">
                    <h3
                      className="text-md font-bold"
                      style={{ color: Colors.Black, marginBottom: "0" }}
                    >
                      {report?.reasons
                        ?.filter((reason) => predefinedReasons.includes(reason)) // Only include predefined reasons
                        .map((reason, index, filteredReasons) => (
                          <span key={index}>
                            {reason}
                            {index !== filteredReasons.length - 1 && ","}{" "}
                            {/* Add comma except for the last item */}
                          </span>
                        ))}
                    </h3>
                    <p
                      className="mt-2 text-xs break-all"
                      style={{ color: Colors.LightGray }}
                    >
                      {/* Print any unmatched reasons */}
                      {report?.reasons?.filter(
                        (reason) => !predefinedReasons.includes(reason)
                      ).length > 0 && (
                        <div>
                          <strong>Others: </strong>
                          {report?.reasons
                            ?.filter(
                              (reason) => !predefinedReasons.includes(reason)
                            )
                            .join(", ")}
                        </div>
                      )}
                    </p>
                  </Col>

                  {/* Reported User Section */}
                  <Col span={24}>
                    {/* Divider */}
                    <Col span={24}>
                      <div className="border-b-2 h-px mb-6 border-dotted border-gray-300"></div>
                    </Col>

                    <Row justify="space-between" className="">
                      {/* Author's Information */}
                      <Col>
                        <Row align="">
                          <Col>
                            <img
                              src={
                                reportType === "interview"
                                  ? report?.item?.slot?.artist?.profile_photo
                                    ? `${s3Bucket}${report?.item?.slot?.artist?.profile_photo}`
                                    : Profile
                                  : report?.item?.author?.profile_photo
                                  ? `${s3Bucket}${report?.item?.author?.profile_photo}`
                                  : Profile
                              }
                              alt="User"
                              className="w-12 h-12 rounded-full mb-0"
                            />
                          </Col>
                          <Col style={{ marginLeft: "5px", padding: "0" }}>
                            <TruncatedName
                              name={
                                reportType === "interview"
                                  ? report?.item?.slot?.artist?.name
                                  : report?.item?.author?.name
                              }
                              maxLength={9}
                              className="text-md font-bold mb-0"
                              style={{ margin: "0", padding: "0" }}
                            />
                            <TruncatedEmail
                              email={
                                reportType === "interview"
                                  ? report?.item?.slot?.artist?.email
                                  : report?.item?.author?.email
                              }
                              maxLength={14}
                              style={{
                                color: Colors.LightGray,
                                margin: "0",
                                padding: "0",
                              }}
                            />
                            <p
                              className="text-xs"
                              style={{ margin: "0", padding: "0" }}
                            >
                              {reportType === "interview"
                                ? report?.item?.slot?.artist?.city
                                : report?.item?.author?.city}
                            </p>
                          </Col>
                        </Row>
                      </Col>

                      {/* Reporter Role */}
                      <Col>
                        <h3
                          className="font-bold text-right"
                          style={{ color: Colors.YellowText }}
                        >
                          {report?.item?.author?.role?.name
                            ? report.item.author.role.name
                                .charAt(0)
                                .toUpperCase() +
                              report.item.author.role.name.slice(1)
                            : ""}
                        </h3>
                      </Col>

                      <Col span={24} className="flex flex-col text-left">
                        <h3
                          className="text-md font-bold"
                          style={{ color: Colors.Black, marginBottom: "0" }}
                        >
                          {report?.item?.title}
                        </h3>
                        <p
                          className="mt-2 text-xs break-all"
                          style={{ color: Colors.LightGray }}
                        >
                          {report?.item?.description}
                        </p>
                      </Col>

                      <Col>
                        {/* Image Grid Design goes here */}
                        <div style={{ marginTop: "5px" }}>
                          <ImageGrid
                            media={report?.item?.media}
                            s3Bucket={s3Bucket}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  {/* Add Poll Type Section */}
                  {report?.item?.type === "poll" && (
                    <Row>
                      <Col span={24}>
                        {report?.item?.options?.length > 0 && (
                          <>
                            {report.item.options.length > 2
                              ? report.item.options
                                  .slice(0, 2)
                                  .map((option) => (
                                    <p
                                      key={option.id}
                                      className="text-sm"
                                      style={{
                                        color: Colors.LightGray,
                                        width: "100%",
                                        border: `1px solid ${Colors.Border}`,
                                        textAlign: "center",
                                        padding: "8px 0",
                                        margin: "4px 0",
                                        borderRadius: "8px",
                                      }}
                                      onClick={() => handleOptionClick(option)} // Set selected option on click
                                    >
                                      {option.option}
                                    </p>
                                  ))
                              : report.item.options.map((option) => (
                                  <p
                                    key={option.id}
                                    className="text-sm"
                                    style={{ color: Colors.LightGray }}
                                    onClick={() => handleOptionClick(option)} // Set selected option on click
                                  >
                                    {option.option}
                                  </p>
                                ))}

                            {report.item.options.length > 2 && (
                              <button
                                type="button"
                                onClick={() => handleSeeMore(report?.item)}
                                style={{
                                  color: Colors.BlueText,
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                }}
                              >
                                See More
                              </button>
                            )}
                          </>
                        )}

                        <Modal.Basic
                          open={isModalVisible}
                          onCancel={handleModalClose}
                          footer={null}
                        >
                          {selectedData && (
                            <React.Fragment>
                              <h1>{selectedData?.title}</h1>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "8px",
                                }}
                              >
                                {selectedData?.options.map((option) => (
                                  <p
                                    key={option.id}
                                    className="text-sm"
                                    style={{
                                      flex: "1 1 calc(50% - 8px)",
                                      color: Colors.LightGray,
                                      border: `1px solid ${Colors.Border}`,
                                      textAlign: "center",
                                      padding: "8px 0",
                                      margin: "4px 0",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    {option.option}
                                  </p>
                                ))}
                              </div>
                            </React.Fragment>
                          )}
                        </Modal.Basic>
                      </Col>
                    </Row>
                  )}

                  {/* Action Buttons */}
                  <Col span={24}>
                    <Row justify="center" gutter={16}>
                      <Col xs={24} lg={12}>
                        <Button.Basic
                          onClick={() => handleDelete(report?.item?.id)}
                          text={
                            reportType === "interview"
                              ? "Delete Interview"
                              : "Delete Post"
                          }
                          size={"medium"}
                          buttonStyle={{
                            width: "100%",
                            backgroundColor: Colors.Pink,
                            display: "flex",
                            justifyContent: "center",
                            color: Colors.White,
                          }}
                        />
                      </Col>
                      <Col xs={24} lg={12}>
                        <Button.Basic
                          onClick={() =>
                            handleSuspendUser(
                              reportType === "interview"
                                ? report?.item?.slot?.artist?.id
                                : report?.item?.author?.id,
                              report?.id
                            )
                          }
                          text={
                            (reportType === "interview"
                              ? report?.item?.slot?.artist?.status
                              : report?.item?.author?.status) === "active"
                              ? "Suspend User"
                              : "Activate User"
                          }
                          size={"medium"}
                          buttonStyle={{
                            width: "100%",
                            backgroundColor: Colors.Black,
                            color: Colors.White,
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        />
                      </Col>
                      <Col xs={24} lg={24} md={24}>
                        <Button.Basic
                          onClick={() =>
                            handleSuspendReporter(
                              report?.reporter?.id,
                              report?.id
                            )
                          }
                          text={
                            report?.reporter?.status === "active"
                              ? "Suspend Reporter"
                              : "Activate Reporter"
                          }
                          size={"medium"}
                          buttonStyle={{
                            backgroundColor: Colors.BlueText,
                            color: Colors.White,
                            marginTop: "5px",
                          }}
                          className="w-full"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        </Row>
      </Spin>

      <Pagination
        current={page}
        pageSize={perPage}
        total={total}
        onChange={(page) => {
          setPage(page);
          fetchReports(page);
        }}
        style={{ marginTop: "20px", textAlign: "center" }}
      />
    </div>
  );
};

export default ReportManagement;
